import { useEffect, useState } from "react";
import { FragmentDefinitionNode } from "graphql/language/ast";
import { ApolloClient, useApolloClient, DocumentNode, gql } from "@apollo/client";

export abstract class GraphQLQueryBase {
    abstract getFragment(): DocumentNode;

    abstract setData(data: any): void;
}

export abstract class FetcherBase {
    abstract fetch(): Promise<any>;
}

function generateQuery(contexts: GraphQLQueryBase[]): string {
    const fragmentNames: string[] = [];
    const fragments: string[] = [];

    for (const context of contexts) {
        const fragment = context.getFragment();
        const fragmentDefinition = fragment.definitions[0] as FragmentDefinitionNode;
        fragmentNames.push("..." + fragmentDefinition.name.value);
        fragments.push(fragment.loc.source.body);
    }

    return `
        query InitialContextFetch {
            ${fragmentNames.join("")}
        }
        ${fragments.join("\n")}
    `;
}

async function fetchContextData(
    client: ApolloClient<object>,
    graphqlQueries: GraphQLQueryBase[],
    fetchers: FetcherBase[],
) {
    let query: string;

    if (graphqlQueries.length > 0) query = generateQuery(graphqlQueries);

    const promises = fetchers.map((f) => f.fetch());

    if (query) promises.push(client.query({ query: gql(query), context: { noAuth: true } }));

    const responses = await Promise.all(promises);

    const gqlResponseData = responses.pop();

    for (const graphqlQuery of graphqlQueries) graphqlQuery.setData(gqlResponseData.data);
}

export function useContextDataFetcher(graphqlQueries: GraphQLQueryBase[], fetchers: FetcherBase[]) {
    const [ready, setReady] = useState(false);
    const client = useApolloClient();

    useEffect(() => {
        fetchContextData(client, graphqlQueries, fetchers).then(() => {
            setReady(true);
        });
    }, []);

    return { ready };
}
